import React from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";

const CustomDatePicker = ({ onChange, placeholder, date, className }) => {


  const convert = (date, format = "YYYY/MM/DD") => {
    let object = { date, format };
    onChange(
      String(new DateObject(object).convert(persian, persian_en).format())
    );
  };

  return (
    <DatePicker
      value={date}
      calendar={persian}
      highlightToday={false}
      onChange={(e) => convert(e)}
      locale={persian_fa}
      placeholder={placeholder || "انتخاب تاریخ"}
      className={className ? className : ""}
    />
  );
};
export default CustomDatePicker;
